import React, { VFC } from 'react';
import styled from 'styled-components';
import { useSettings } from '../../contexts/settingsContext';
import { useTranslation } from '../../contexts/translationContext';
import { theme } from '../../utils/theme';
import { IconVariants } from '../atoms/icons/types';
import SvgIcon from '../atoms/SvgIcon';
import { ITranslation } from '../atoms/Typography';

interface Props extends React.HTMLProps<HTMLInputElement>, ITranslation {
  title?: string;
  active?: boolean;
  radius?: string;
  placeholder?: string;
  placeholderParams?: string;
  icon?: IconVariants;
  font?: string;
}

const StyledTextInputContainer = styled.div<Props>`
  display: flex;
  height: 36px;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding-right: 16px;
  border-radius: ${({ radius }) => radius || '4px'};
  border: 1px solid #cccccc;
  :disabled {
    color: ${theme.colors.grey[20]};
    outline: none;
  }
`;

const StyledTextInput = styled.input<Props>`
  display: inline-grid;
  grid-area: 1/1/2/3;
  width: 100%;
  background-color: transparent;
  padding: 2px 8px;
  margin: 2px;
  outline: none;
  font-family: ${({ font }) => font};
  font-size: 1.175rem;
  border: none;
  :placeholder {
    letter-spacing: 45%;
  }
`;

const SearchInput: VFC<Props> = ({
  placeholder,
  disabled,
  onChange,
  icon,
  value,
}) => {
  const { translate } = useTranslation();
  const { cornerRadius, fontFamily } = useSettings();

  const translatedPlaceholder = placeholder && translate(placeholder, null);

  return (
    <StyledTextInputContainer radius={cornerRadius}>
      <StyledTextInput
        font={fontFamily}
        value={value}
        disabled={disabled}
        placeholder={translatedPlaceholder}
        onChange={onChange}
      />
      {icon && (
        <SvgIcon color={theme.colors.grey[100]} icon={icon} iconSize="small" />
      )}
    </StyledTextInputContainer>
  );
};

export default SearchInput;
